import { createSelector } from 'reselect';
import { groupIdSelector } from '../router/selectors';
import {
  creditsByIdSelector,
  creditsByInstanceIdSelector
} from '../credits/selectors';

const groupsStateSelector = (state) => state.get('groups');

export const groupsSelector = createSelector(
  groupsStateSelector,
  ({ groups }) => groups
);

export const groupInstancesSelector = createSelector(
  groupsStateSelector,
  ({ instances }) => instances
);

export const activeGroupSelector = createSelector(
  groupIdSelector,
  groupsSelector,
  (groupId, groups) => groups.find(({ id }) => id === groupId)
);

export const activeGroupInstancesSelector = createSelector(
  groupIdSelector,
  groupInstancesSelector,
  (groupId, instances) => instances[groupId] || []
);

export const instancesWithCreditsSelector = createSelector(
  activeGroupInstancesSelector,
  creditsByIdSelector,
  creditsByInstanceIdSelector,
  (instances, crById, crByInstanceId) => {
    const creditsById = crById.toJS();
    const creditsByInstanceId = crByInstanceId.toJS();
    return instances.map((instance) => {
      const creditIds = creditsByInstanceId[instance.id] || [];
      const credits = creditIds.map((id) => creditsById[id]);
      return { ...instance, credits };
    });
  }
);
